import React, { useState } from "react";
import { Radio, DatePicker, Checkbox, Form, Input } from "antd";
import dayjs from "dayjs";

function ManagementFees({ initialValues }) {
  const [comissionType, setCommissionType] = useState("Percent");

  const monthFormat = "YYYY/MM";

  const validatePercentage = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }

    const percentageRegex = /^\d{1,2}(\.\d{1,2})?%?$/;
    if (!percentageRegex.test(value)) {
      return Promise.reject(
        "Please enter a valid percentage in the format xx.xx"
      );
    }

    return Promise.resolve();
  };
  const validateNumber = (_, value) => {
    if (isNaN(value) || value < 0) {
      return Promise.reject(
        new Error("Please enter a valid flat fee less than 100")
      );
    }
    return Promise.resolve();
  };

  return (
    <>
      <Form.Item label="Start Date" name="managementFeeStartDate">
        <DatePicker
          format={monthFormat}
          picker="month"
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Form.Item
        label="Waive Fee when Vacant"
        name="waiveFee"
        valuePropName="checked"
      >
        <Checkbox></Checkbox>
      </Form.Item>
      <Form.Item label="Fee Type" name="feeType">
        <Radio.Group
          name="radiogroup"
          value={comissionType}
          onChange={(e) => {
            setCommissionType(e.target.value);
          }}
        >
          <Radio value="Flat">Flat</Radio>
          <Radio value="Percent">Percent</Radio>
        </Radio.Group>
      </Form.Item>

      {comissionType === "Flat" ? (
        <Form.Item
          label="Management Flat Fee"
          rules={[{ required: true, validator: validateNumber }]}
          name="amount"
        >
          <Input prefix="$" />
        </Form.Item>
      ) : (
        <>
          <Form.Item
            label="Management Fee Percent"
            rules={[{ required: true, validator: validatePercentage }]}
            name="amount"
          >
            <Input suffix="%" />
          </Form.Item>
          <Form.Item
            label="Minimum Management Fee"
            name="minimumFee"
            rules={[
              {
                validator: validateNumber,
              },
            ]}
            initialValue={initialValues.minimumFee}
          >
            <Input prefix="$" />
          </Form.Item>
          <Form.Item
            label="Maximum Management Fee"
            name="maximumFee"
            rules={[
              {
                validator: validateNumber,
              },
            ]}
            initialValue={initialValues.maximumFee}
          >
            <Input prefix="$" />
          </Form.Item>
        </>
      )}
    </>
  );
}

export default ManagementFees;
